<template>
    <div class="addressselect">
        <el-popover
                ref="popover1"
                placement="bottom"
                width="300"
                trigger="hover">
            <c-checkboxgroup :isMutual="true" :source="provinces" :value="province"
                             @input="changeProvince"></c-checkboxgroup>
        </el-popover>
        <el-popover
                ref="popover2"
                placement="bottom"
                width="300"
                trigger="hover">
            <c-checkboxgroup :isMutual="true" :source="citys" :value="city" @input="changeCity"></c-checkboxgroup>
        </el-popover>
        <el-popover
                ref="popover3"
                placement="bottom"
                width="300"
                trigger="hover">
            <c-checkboxgroup :isMutual="true" :source="countys" :value="county" @input="changeCounty"></c-checkboxgroup>
        </el-popover>
        <div class="input-group" style="width: 100%;">
            <span v-if="label.length>0" class="input-group-addon">
             <span class="gray">{{label}}</span>
            </span>
            <div class="fg-line">
                <div style="display: flex">
                    <div class="item">
                        <c-textbox v-popover:popover1 :isEnabled="false" :lable="label" type="text" placeholder="省"
                                   :value="ProvinceName"></c-textbox>
                    </div>
                    <div class="item">
                        <c-textbox v-popover:popover2 :isEnabled="false" :lable="label" type="text" placeholder="市"
                                   :value="CityName"></c-textbox>
                    </div>
                    <div class="item">
                        <c-textbox v-popover:popover3 :isEnabled="false" :lable="label" type="text" placeholder="县"
                                   :value="CountyName"></c-textbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .addressselect .item {
        padding-right: 5px;
    }
</style>
<script>
    import addsrc from 'services/AddressService'
    export default{
        name: 'c-addressselect',
        props: {
            /*左边Label*/
            label: {
                type: String,
                default: function () {
                    return "";
                }
            },
            placeholder: {
                type: String,
                default: function () {
                    return "";
                }
            },
            /*地区的值*/
            value: {
                default: function () {
                    return "";
                }
            }
        },
        data(){
            return {
                provinces: [],
                citys: [],
                countys: [],
                province: null,
                city: null,
                county: null
            }
        },
        mounted(){
            this.init();
            this.reloadAddressInfo();
        },
        watch: {
            value: {
                handler(val){
                    if (val) {
                        this.reloadAddressInfo();
                    }
                },
                deep: true
            },
            AddressCode: {
                handler(val){
                    this.$emit('input', String(val));
                },
                deep: true
            }
        },
        computed: {
            AddressCode(){
                if (this.county) {
                    return this.county;
                }
                else if (this.city) {
                    return this.city;
                }
                else if (this.province) {
                    return this.province;
                }
                else {
                    return null;
                }
            },
            ProvinceName(){
                if (this.province &&
                    this.provinces &&
                    this.provinces.length > 0) {
                    let name = '';
                    var that = this;
                    this.provinces.forEach(function (item) {
                        if (that.province == item.value) {
                            name = item.text;
                        }
                    });
                    return name;
                }
                return ''
            },
            CityName(){
                if (this.city &&
                    this.citys &&
                    this.citys.length > 0) {
                    let name = '';
                    var that = this;
                    this.citys.forEach(function (item) {
                        if (that.city == item.value) {
                            name = item.text;
                        }
                    });
                    return name;
                }
                return ''
            },
            CountyName(){
                if (this.county &&
                    this.countys &&
                    this.countys.length > 0) {
                    let name = '';
                    var that = this;
                    this.countys.forEach(function (item) {
                        if (that.county == item.value) {
                            name = item.text;
                        }
                    });
                    return name;
                }
                return ''
            }
        },
        methods: {
            changeProvince(val){
                this.province = val;
                this.city = null;
                this.countys = [];
                this.county = null;
                this.initCitys(val);
            },
            changeCity(val){
                this.city = val;
                this.county = null;
                this.initAreas(val);
            },
            changeCounty(val){
                this.county = val;
            },
            init(){
                this.initProvince();
            },
            initProvince(){
                this.provinces = [];
                return addsrc.getProvinces().then((ret) => {
                    let att = [];
                    if (ret && ret.length > 0) {
                        ret.forEach(function (item) {
                            att.push({
                                text: item.ProviceName,
                                value: item.ProviceCode
                            });
                        });
                    }
                    this.provinces = att;
                });
            },
            initCitys(ID){
                if (!ID)return;
                this.citys = [];
                return addsrc.getcitys(ID).then((ret) => {
                    let att = [];
                    if (ret && ret.length > 0) {
                        ret.forEach(function (item) {
                            att.push({
                                text: item.CityName,
                                value: item.CityCode
                            });
                        });
                    }
                    this.citys = att;
                });
            },
            initAreas(ID){
                if (!ID)return;
                this.countys = [];
                return addsrc.getareas(ID).then((ret) => {
                    let att = [];
                    if (ret && ret.length > 0) {
                        ret.forEach(function (item) {
                            att.push({
                                text: item.AreaName,
                                value: item.AreaCode
                            });
                        });
                    }
                    this.countys = att;
                });
            },
            //根据code刷新控件的值。
            reloadAddressInfo(){
                let code1 = null;
                let code2 = null;
                let code3 = null;
                let Code = this.value;
                Code = String(Code);
                if (Code && Code > 0) {
                    if (Code.length == 6) {
                        code1 = Code.slice(0, 2);
                        code2 = Code.slice(0, 4);
                        code3 = Code.slice(0, 6);
                    }
                    else if (Code.length == 4) {
                        code1 = Code.slice(0, 2);
                        code2 = Code.slice(0, 4);
                    }
                    else if (Code.length == 2) {
                        code1 = Code.slice(0, 2);
                    }
                    if (code1) {
                        if(code1!=this.province){
                            this.province = code1;
                            this.initCitys(code1);
                        }
                        if (code2) {
                            if(this.city!=code2){
                                this.city = code2;
                                this.initAreas(code2);
                            }
                        }
                        if (code3) {
                            this.county = code3;
                        }
                    }
                }
            }
        },
        components: {}
    }
</script>



// WEBPACK FOOTER //
// addressselect.vue?ace27858